/**
 * Hook misji Misi „ułóż 3 klocki na półce" — tylko EMIT (WP-V2-QC).
 */
import type { InteractEvent } from '../../interact/index.js';
import {
  SCHOOL_QUEST_ID,
  isLetterBlockDef,
  shelfSlotForBlock,
} from './objects.js';

export const INTERACT_BUS_EVENT = 'pieskowo:interact';

export type SchoolMissionPayload = {
  sceneKey: 'School';
  questId: typeof SCHOOL_QUEST_ID;
  stepKind: 'place_block';
  interact: InteractEvent;
};

export function isBlockSnapToShelf(evt: InteractEvent): boolean {
  return (
    evt.type === 'snap' &&
    evt.snapZoneId === shelfSlotForBlock(evt.defId) &&
    isLetterBlockDef(evt.defId)
  );
}

export type SchoolShelfProgress = {
  completed: string[];
  done: boolean;
};

export function createSchoolShelfProgress(): SchoolShelfProgress {
  return { completed: [], done: false };
}

export function recordSchoolShelfSnap(
  progress: SchoolShelfProgress,
  defId: string,
  snapZoneId: string,
): SchoolShelfProgress {
  if (
    !isLetterBlockDef(defId) ||
    shelfSlotForBlock(defId) !== snapZoneId ||
    progress.completed.includes(defId)
  ) {
    return progress;
  }
  const completed = [...progress.completed, defId].sort();
  return { completed, done: completed.length === 4 };
}

export function schoolMissionFromInteract(
  evt: InteractEvent,
): SchoolMissionPayload | null {
  if (!isBlockSnapToShelf(evt)) return null;
  return {
    sceneKey: 'School',
    questId: SCHOOL_QUEST_ID,
    stepKind: 'place_block',
    interact: evt,
  };
}
